import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Paper, CircularProgress, Alert, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { authService } from '../api';
import { useTranslation } from 'react-i18next';

const Auth = ({ onLoginSuccess }) => {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const response = await authService.login(email, password);
            localStorage.setItem('token', response.data.access);
            // El refresh token ahora se maneja automáticamente vía cookies HttpOnly
            // por lo que no es necesario (ni posible) guardarlo manualmente aquí.
            const userRole = response.data.user_role || 'USER';
            onLoginSuccess(userRole);
        } catch (err) {
            console.error("Login error:", err.response?.data || err.message);
            setError(err.response?.data?.detail || t("login_invalid_credentials"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                // Account for AppBar height (64px) and main Box padding (2 * 24px = 48px)
                minHeight: 'calc(100vh - 112px)',
                // No need for p:3 here, as the parent Box in App.js already applies it.
                // If this Box also had p:3, it would be double padding.
            }}
        >
            <Paper
                elevation={6} // Increased elevation for M3 look
                sx={{
                    p: { xs: 4, md: 6 }, // Responsive padding inside the Paper
                    borderRadius: 4, // M3 pill-like shape (32px)
                    maxWidth: 450,
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    textAlign: 'center',
                    border: (theme) => `1px solid ${theme.palette.divider}`, // Subtle border for definition
                }}
            >
                <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
                    {t('login_title')}
                </Typography>
                {error && <Alert severity="error">{error}</Alert>}
                <form onSubmit={handleSubmit}>
                    <TextField label={t('login_email')} type="email" fullWidth margin="normal" value={email} onChange={(e) => setEmail(e.target.value)} required />
                    <TextField label={t('login_password')} type="password" fullWidth margin="normal" value={password} onChange={(e) => setPassword(e.target.value)} required />
                    <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }} disabled={loading}>
                        {loading ? <CircularProgress size={24} /> : t('login_button')}
                    </Button>
                </form>
                {/* Optionally add a forgot password link if needed */}
                <Link component="button" variant="body2" onClick={() => navigate('/forgot-password')} sx={{ mt: 1 }}>
                    {t('login_forgot_password')}
                </Link>
                <Box sx={{ mt: 1 }}>
                    <Link component="button" variant="body2" onClick={() => navigate('/signup')} underline="hover">
                        {t('login_signup_link')}
                    </Link>
                </Box>
            </Paper>
        </Box>
    );
};

export default Auth;